// The 配空 (Pair Empty) / 提重 (Pickup) / 还空 (Empty Return) / 转仓 (Transfer)
// dispatch buttons and the whole manual pairing/leg-dispatch workflow behind
// them lived in this file. Alan asked for them removed, buttons and workflow
// together ("连同背后的整个流程一起删掉"), confirmed after being told the
// consequences (2026-09-28) - so the state machine, the split-view wiring, the
// write plan and the button/notice markup are gone from here and from app.js
// and dashboard-query-controls.mjs, which were their only callers.
//
// Two other paths to a Container's canonical `empty_returned` status are
// UNCHANGED and do not live in this file:
//   (a) the inline `actual_empty_returned_at` cell/field edit
//       (container-field-registry.mjs, container-task-modal.mjs, the
//       dashboard's own autosave), and
//   (b) the driver-evidence Empty Return review queue
//       (today-work-queue.mjs -> `#/action/:id` -> the reviewEmptyReturnEvidence
//       callable -> functions/src/empty-return-review-service.ts and
//       container-workflow.ts), which is the only thing that may actually set
//       `empty_returned` - a driver completing a task never does.
//
// What remains below is unrelated to that workflow: container-task-modal.mjs
// imports these three for its OWN release button's terminal-fees hold, which
// applies to every release that button makes, pairing or not. Removing them
// would break that modal, so they stay.
export const TERMINAL_FEES_HOLD_RELEASE = false;

/**
 * Whether the terminal fees are settled, which is what lets a box move through
 * the gate. Both fees, each either paid by us or paid by the customer (Alan,
 * 2026-08-16: 两个都是 paid 才算; customer_paid 算).
 *
 * The two statuses are stored explicitly when Finance has answered, and folded
 * into the older `ctf_tmf_status` "a/b/c" string on rows that predate the split
 * - both are read, explicit first, the same way the table's own fee editor does.
 */
export function rowTerminalFeesSettled(row) {
  const parts = String(row?.ctf_tmf_status ?? '').split('/').map((part) => part.trim().toLowerCase());
  const settled = (explicit, folded) => {
    const token = String(explicit ?? folded ?? '').trim().toLowerCase();
    return token === 'paid' || token === 'customer_paid';
  };
  const customerPaid = row?.customer_paid === true || parts[2] === 'customer_paid';
  return (customerPaid || settled(row?.ctf_status, parts[0]))
    && (customerPaid || settled(row?.tmf_status, parts[1]));
}

/**
 * Whether this Container may be released at all, and why not when it may not.
 *
 * Every leg that moves the box through a terminal gate waits on the fees
 * (Alan, 2026-08-16). TERMINAL_FEES_HOLD_RELEASE is false (see above), so this
 * still names the reason for the warning but never blocks a release on it.
 *
 * Returns null when nothing stands in the way, or a code the copy tables carry.
 */
export function pairingReleaseBlocker(row) {
  if (rowTerminalFeesSettled(row)) return null;
  return 'TERMINAL_FEES_UNPAID';
}

// A reported empty is exactly what the Empty chip counts: Ocean Status
// empty_return_reported, and not one whose return has already been stamped.
// This used to test `reported_empty_at`, which the projected row does not carry
// - it is null on every row - so the filter matched nothing and blanked the
// table while the chip beside it said 10. The chip and this must read the same
// field or the operator is told two different things at once.
export function pairingIsReportedEmpty(row) {
  return row?.ocean_status === 'empty_return_reported' && !row?.actual_empty_returned_at;
}
